<template>
  <div class="flowMainViewContainer company-do-audit">
    <div class="flowViewContainer view-content" :style="viewContainerStyleNew">
      <div class="flowViewLeftBox step-content">
        <flow
          style="margin-left:auto;margin-right:auto"
          :editable="flowEditable"
          :checkable="flowEelectable"
          :steps="flowData"
          @selectedStep="activityStep"
        />
      </div>
      <div class="flowViewRightBox checklist-content">
        <div class="top-title">{{ stepName }}</div>
        <div class="action">{{ $t("formData.action") }}</div>
        <div class="line" />
        <div class="checklist-main">
          <checklist :type="checkListType" :data="checkListData" />
        </div>
      </div>
    </div>
    <div v-if="approvalLogList && approvalLogList.length > 0" class="approvalLogContainer">
      <div class="collapse-custom-item">
        <div class="collapse-item-title" @click="showContent('isApprovalLogShow')">
          <span class="collapse-item-title-content">{{ $t("formData.approvalHistoryLog") }}</span>
          <i :class="(isApprovalLogShow ? 'el-icon-ali-shangla' : 'el-icon-ali-xiala') + ' collapse-item-title-icon'" />
        </div>
      </div>
      <!-- <div class="approvalLogTitle">{{ $t("formData.approvalHistoryLog") }}</div> -->
      <div class="approvalLogList" v-show="isApprovalLogShow">
        <template v-for="(logItem, logIndex) in approvalLogList">
          <div
            :key="logIndex"
            :class="'approvalLogItem ' + (logIndex < approvalLogList.length - 1 ? 'approvalLogItemBorder' : '')"
          >
            <div class="userInfo">
              <div class="userImg">
                <headimg
                  :size="elAvatarSize"
                  icon="el-icon-user-solid"
                  :src="logItem.userImgSrc ? logItem.userImgSrc : require('@/assets/phone.jpg')"
                />
              </div>
              <div class="userName">{{ logItem.userName }}</div>
            </div>
            <div class="logInfo">
              <div
                class="logInfoItem"
              >{{ $t("formData.action") }}：{{ $t(actionStatusList[logItem.status]) }}</div>
              <div
                class="logInfoItem logInfoItemMargin"
                v-if="logItem.status==0||logItem.status==1"
              >{{ $t("formData.reason") }}：{{ logItem.reason }}</div>
              <div
                class="logInfoItem logInfoItemMargin"
              >{{ $t("formData.time") }}：{{ logItem.time }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="flowFooterBarCustom approve-button">
      <cus-btn type="cancel" @click="cancel()" />
    </div>
  </div>
</template>

<script>
import { getCompanyFlowDetail } from "@/api/approvalProcess";
export default {
  components: {},
  props: {},
  data() {
    return {
      isApprovalLogShow: false,//是否显示审批日志
      mainViewContainerStyleNew: '',//主容器计算样式
      viewContainerStyleNew: '',//view容器计算样式
      viewContainerMinHeightNew: 400,//view容器计算时的最小高度
      viewContainerMaxHeightNew: 550,//view容器计算时的最大高度
      elAvatarSize: 50,
      flowData: [],
      flowEditable: false,
      flowEelectable: false,
      checkListData: [],
      checkListType: "editview",
      approvalLogList: [],
      stepName: "",
      backToPage: "companyProcessAudit",
      actionStatusList: [
        "formData.pass",
        "formData.reject",
        "formData.submit",
        "formData.systemSync"
      ]
    };
  },
  computed: {},
  watch: {},
  created() {
    getCompanyFlowDetail(this.$route.query.id).then(res => {
      const isApprove = res.data.status == 2//是否通过
      this.flowData = res.data.companyPhases
        .filter(step => {
          return step.status == 0;
        })
        .map(step => {
          return {
            stepName: step.stageName,
            checklist: step.companyChecks
              ? step.companyChecks.map(checkitem => {
                  return {
                    content: checkitem.introduction,
                    isNeedAttachments: checkitem.isAttachments == 1,
                    isSchedule: checkitem.isSchedule == 1,
                    link: checkitem.link,
                    linkList: checkitem.checkLinks
                      ? checkitem.checkLinks.map(link => {
                          return {
                            linkName: link.linkName,
                            hyperlink: link.link
                          };
                        })
                      : [],
                    fileList: checkitem.companyFile
                      ? checkitem.companyFile.map(file => {
                          return {
                            filename: file.fileName,
                            filepath: file.fileUrl
                          };
                        })
                      : [],
                    modified: checkitem.isHighlight == 1 // 是否高亮(0-否 1-是)，通过时为不高亮
                  };
                })
              : [],
            selected: false,
            modified: step.isHighlight == 1 // 是否高亮(0-否 1-是)，通过时为不高亮
          };
        });
      this.checkListData = this.flowData[0].checklist;
      this.stepName = this.flowData[0].stepName;
      this.flowData[0].selected = true;
      this.approvalLogList = res.data.companyApprovals.map(approval => {
        return {
          userImgSrc: approval.memberImg,
          userName: approval.actionName,
          status: approval.status,
          action:
            approval.status == 0
              ? this.$t("button.approve")
              : this.$t("button.reject"),
          reason: approval.reason,
          time: this.dateFormatToyyyyMMdd(approval.time, null, "second")
        };
      });

      this.computeViewContainerStyle()//计算容器样式
    });
  },
  mounted() {},
  methods: {
    /**
     * 显示隐藏内容
     */
    showContent(name){
      if(!name){
        return
      }
      this[name] = !this[name]
    },
    
    /**
     * 计算容器样式
     */
    computeViewContainerStyle(){
      //计算方法
      let computeFun = function(){
          //有审批日志时，重新计算流程阶段容器高度
          let flowMainViewContainerArray = document.getElementsByClassName("flowMainViewContainer")//整个容器
          let flowViewContainerArray = document.getElementsByClassName("flowViewContainer")//流程阶段容器
          let flowViewLeftBoxArray = document.getElementsByClassName("flowViewLeftBox")//流程基础信息容器、流程阶段容器
          let flowViewRightBoxArray = document.getElementsByClassName("flowViewRightBox")//流程阶段容器、流程阶段checklist容器
          let flowViewLeftBoxS2Array = document.getElementsByClassName("flowViewLeftBoxS2")//流程阶段容器
          let flowViewRightBoxS2Array = document.getElementsByClassName("flowViewRightBoxS2")//流程阶段checklist容器
          let approvalLogContainerArray = document.getElementsByClassName("approvalLogContainer")//审批日志容器
          let flowViewTopBoxS2Array = document.getElementsByClassName("flowViewTopBoxS2")//基础信息容器
          let flowFooterBarCustomArray = document.getElementsByClassName("flowFooterBarCustom")//按钮行容器
          let viewContainerMinHeightNew = this.viewContainerMinHeightNew//view容器计算时的最小高度
          let viewContainerMaxHeightNew = this.viewContainerMaxHeightNew//view容器计算时的最大高度
          let flowViewContainerHeightTemp = 0;
          let marginTotal = 15//margin总计=流程阶段

          //如果是下一页的页面，则用S2代替S1
          if(flowViewLeftBoxS2Array && flowViewLeftBoxS2Array.length > 0){
            flowViewLeftBoxArray = flowViewLeftBoxS2Array
          }
          if(flowViewRightBoxS2Array && flowViewRightBoxS2Array.length > 0){
            flowViewRightBoxArray = flowViewRightBoxS2Array
          }

          let mainContainerHeight = 0//整个容器高度
          // let flowMainViewContainerHeight = 0//整个容器高度
          if(flowMainViewContainerArray && flowMainViewContainerArray.length > 0){
            // flowMainViewContainerHeight = flowMainViewContainerArray[0].scrollHeight//clientHeight
            mainContainerHeight = flowMainViewContainerArray[0].offsetHeight
            if(flowMainViewContainerArray[0].parentElement){
              mainContainerHeight = flowMainViewContainerArray[0].parentElement.offsetHeight
            }
          }
          // let flowViewContainerHeight = 0//流程阶段容器高度
          // if(flowViewContainerArray && flowViewContainerArray.length > 0){
          //   flowViewContainerHeight = flowViewContainerArray[0].scrollHeight//clientHeight
          // }
          let flowViewLeftBoxHeight = 0//流程阶段容器高度
          if(flowViewLeftBoxArray && flowViewLeftBoxArray.length > 0){
            flowViewLeftBoxHeight = flowViewLeftBoxArray[0].scrollHeight//clientHeight
          }
          let flowViewRightBoxHeight = 0//流程阶段checklist容器高度
          if(flowViewRightBoxArray && flowViewRightBoxArray.length > 0){
            flowViewRightBoxHeight = flowViewRightBoxArray[0].scrollHeight//clientHeight
          }
          let approvalLogContainerHeight = 0//审批日志容器高度
          if(approvalLogContainerArray && approvalLogContainerArray.length > 0){
            approvalLogContainerHeight = approvalLogContainerArray[0].offsetHeight//clientHeight
          }
          let flowViewTopBoxS2Height = 0//基础信息容器高度
          if(flowViewTopBoxS2Array && flowViewTopBoxS2Array.length > 0){
            flowViewTopBoxS2Height = flowViewTopBoxS2Array[0].offsetHeight//clientHeight
            marginTotal += 10//加上基础信息margin
          }
          let flowFooterBarCustomHeight = 0//按钮行容器高度
          if(flowFooterBarCustomArray && flowFooterBarCustomArray.length > 0){
            flowFooterBarCustomHeight = flowFooterBarCustomArray[0].offsetHeight
          }
          
          // console.log(mainContainerHeight,flowViewContainerHeight,approvalLogContainerHeight,flowViewTopBoxS2Height,flowFooterBarCustomHeight)

          //剩余高度=总高度-审批日志高度-基础信息高度-按钮行高度-margin总计
          let heightTemp = mainContainerHeight - approvalLogContainerHeight 
                - flowViewTopBoxS2Height - flowFooterBarCustomHeight - marginTotal

          //比较左右两边的流程阶段容器大小，取大的值作为容器高度
          if(flowViewLeftBoxHeight > flowViewRightBoxHeight){
            flowViewContainerHeightTemp = flowViewLeftBoxHeight
          }
          else{
            flowViewContainerHeightTemp = flowViewRightBoxHeight
          }

          //比较容器高度大于最大高度，取最大高度的值
          //比较容器高度小于最小高度，取最小高度的值
          if(flowViewContainerHeightTemp > viewContainerMaxHeightNew){
            flowViewContainerHeightTemp = viewContainerMaxHeightNew
          }
          // else if(flowViewContainerHeightTemp < viewContainerMinHeightNew){
          //   flowViewContainerHeightTemp = viewContainerMinHeightNew
          // }

          //剩余高度小于容器计算高度，则用容器计算高度，否则用剩余高度
          if(heightTemp < flowViewContainerHeightTemp){
            // this.mainViewContainerStyleNew = 'height:auto;'
            // this.viewContainerStyleNew = 'height:' + flowViewContainerHeightTemp.toString() + 'px;'
          }
          else{
            // this.mainViewContainerStyleNew = ''
            // this.viewContainerStyleNew = ''
            flowViewContainerHeightTemp = heightTemp
          }
          // this.mainViewContainerStyleNew = 'height:auto;'
          this.viewContainerStyleNew = 'height:' + flowViewContainerHeightTemp.toString() + 'px;'
      }
      this.$nextTick(computeFun)
    },

    activityStep(step) {
      this.stepName = step.stepName;
      this.checkListData = step.checklist;
    },

    /**
     * 返回上一页
     */
    cancel() {
      let backToPage = this.backToPage;
      if (this.$route.query.backToPage) {
        backToPage = this.$route.query.backToPage;
      }
      this.$router.push({
        name: backToPage
      });
    }
  }
};
</script>
<style  scoped lang="scss">
.company-do-audit{ 
  .collapse-custom-item{
    height: 50px;
    line-height: 50px; 
    background-color: #f4f4f4;
    font-size: 16px;
    font-weight: bold;
    padding: 0 30px;
    // width: 800px;
    // margin: 0 auto;
    // margin-bottom: 10px;
    margin: 0 20px 10px 20px;

    .collapse-item-title{
      display: inline-block;
      cursor: pointer;

      .collapse-item-title-content{
        margin-right: 50px;
      }

      .collapse-item-title-icon{
        color: #3ea9e0;
        font-size: 16px;
        // font-weight: bold;
      }
    }
  }
}

.view-content {
  display: flex;
  min-width: 1080px;
  width: 100%;
  overflow: auto;
  .step-content {
    background-color: white;
    flex-shrink: 0;
    border-radius: 10px;
    // height: 570px;
    overflow: auto;
    min-width: 430px;
  }
  .checklist-content {
    flex-grow: 1;
    border-radius: 10px;
    margin-left: 10px;
    background-color: white;
    box-sizing: border-box;
    padding-top: 30px;
    // height: 570px;
    overflow: auto;
    .top-title {
      font-size: 22px;
      font-weight: 500;
      color: rgba(2, 159, 231, 1);
      padding-left: 20px;
    }
    .action {
      font-size: 22px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-top: 40px;
    }
    .line {
      background-color: #c4c4c4;
      height: 1px;
      margin: 10px 50px 0 50px;
    }
    .checklist-main {
      padding: 0 20px 20px 20px;
    }
  }
}
.approve-content {
  min-width: 1080px;
  width: 100%;
  margin-top: 15px;
  background-color: white;
  border-radius: 10px;
  padding-bottom: 25px;
  margin-bottom: 25px;
  .title {
    padding: 20px 0 0 30px;
    font-size: 26px;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
  }
  .main-content {
    margin-top: 20px;
    .log-item {
      padding: 20px 0;
      display: flex;
      .left {
        width: 230px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        .imgbox {
          width: 66px;
          height: 66px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 100px;
          }
        }
        .namebox {
          font-size: 18px;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          margin-top: 10px;
        }
      }
      .right {
        font-size: 18px;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .line {
      margin: 0 50px;
      height: 1px;
      background-color: #dedede;
    }
  }
}
.approve-button {
  padding: 40px 0;
  text-align: center;
  & > button:nth-child(n + 2) {
    margin-left: 100px;
  }
}

.approvalLogContainer {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  // height: auto;
  margin-top: 15px;
  padding: 20px 0;

  .approvalLogTitle {
    line-height: 30px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    padding: 0 20px;
  }

  .approvalLogList {
    padding: 0 30px;
    margin-top: 30px;

    .approvalLogItem {
      display: flex;
      justify-content: space-between;
      // min-height: 150px;
      padding: 10px 10px 20px 10px;

      .userInfo {
        width: 150px;
        min-width: 150px;
        display: flex;
        flex-wrap: wrap;
        // flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        text-align: center;

        .userImg {
          width: 100%;
          padding: 0 0 0 0;
        }

        .userName {
          word-break: break-all;
          word-wrap: break-word;
          white-space: normal;
          line-height: 25px;
          font-size: 16px;
          color: rgba(38, 38, 38, 1);
          margin-top: 10px;
        }
      }

      .logInfo {
        // width: 100%;
        // flex-basis: 100%;
        flex-grow: 1;
        min-width: 500px;
        margin-left: 20px;
        word-break: break-all;
        word-wrap: break-word;
        white-space: normal;
        line-height: 25px;
        font-size: 16px;
        color: rgba(38, 38, 38, 1);
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;

        .logInfoItem {
          width: 100%;
        }

        .logInfoItemMargin {
          margin: 10px 0 0 0;
        }
      }
    }

    .approvalLogItemBorder {
      border-bottom: #dedede solid 1px;
      // border-radius: 10px;
    }
  }
}
</style>
